export const projectNameIsValid = (projectName: string) => projectName.split(/\s/g).join('') !== '';
